import React from "react";
import { Grid, useMediaQuery, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  imgDiv: {
    display: "flex",
    justifyContent: "center",
    width: "300px",
    height: "300px",
  },
  mainDiv: {
    margin: "2rem 0rem",
  },
  txtDiv: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "center",
  },
  title: {
    paddingTop: "2rem",
    paddingBottom: "1rem",
  },
  txt: {
    padding: "1rem 2rem",
    lineHeight: "3rem",
  },
  container: {
    padding: "4rem 1rem",
  },
}));

const Testimonial = (props) => {
  const { data } = props;
  const theme = useTheme();
  const classes = useStyle(theme);
  const isMobile = useMediaQuery("(max-width:1280px)");
  return (
    <div className={classes.mainDiv}>
      <Grid container className={classes.container}>
        <Grid item lg={6} xs={12} className={classes.imgDiv}>
          {props.children}
        </Grid>
        <Grid item lg={6} xs={12} className={classes.txtDiv}>
          <Typography
            variant="h3"
            style={isMobile ? { textAlign: "center" } : null}
            className={classes.title}
          >
            {props.data.title}
          </Typography>

          <Typography
            variant="h5"
            style={
              isMobile
                ? { padding: "1rem 4rem", textAlign: "start" }
                : { textAlign: "center" }
            }
            className={classes.txt}
          >
            <span style={{ fontSize: "60px", opacity: ".7", color: "#6C63FF" }}>
              "
            </span>
            {data.text}
            <span
              style={{
                fontSize: "60px",
                opacity: ".7",
                color: "#6C63FF",
                position: "absolute",
              }}
            >
              "
            </span>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Testimonial;
